import type { Community } from '@/domain/communities';
import { createContext, useContext } from 'react';

interface AppContextModel {
  community: Community;
  tenantClientUrl?: string;
}

export const AppContext = createContext<AppContextModel>({
  community: null as unknown as Community,
  tenantClientUrl: '',
});

export const useAppContext = () => useContext(AppContext);
